var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 95.49",
    style: {
      enableBackground: "new 0 0 122.88 95.49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill-rule:evenodd;clip-rule:evenodd;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,95.49L0,80.6c7.12-3.17,34.98-10.16,36.74-19.06c0.79-4.01-1.02-5.94-3-9.1l-6.37-10.15 c-1.49-2.39-2.61-3.24-2.58-6.18c0.02-1.66,0.05-3.29,0.29-4.88c0.3-2.03,0.55-2.1,1.62-3.73c0.72-1.1,0.63-1.43,0.63-3.96v-6.3 c0-7.28,2.68-11.84,7.2-14.42c6.62-3.78,20.04-3.78,26.62,0.08c4.44,2.6,7.06,7.14,7.06,14.34v6.3c0,2.83-0.1,2.91,0.93,4.39 c0.78,1.13,0.95,1.26,1.22,2.64c0.34,1.81,0.37,3.65,0.39,5.54c0.04,2.94-1.08,3.79-2.57,6.18l4.62,2.89l0.77-1.12 c1.54-2.24,2.6-3.79,2.64-7.44c0.02-0.18,0.02-0.37,0.02-0.56l-0.02,0c-0.01-1.1-0.03-2.18-0.08-3.04 c-0.07-1.16-0.18-2.32-0.4-3.47c-0.41-2.14-0.71-2.71-1.61-4.02c-0.08-0.14-0.17-0.27-0.26-0.41l0,0l-0.12-0.17l-0.08-0.12l0,0 l-0.01-0.02l-0.01,0c0-0.03,0.04-0.07,0.04-0.58l0-0.69l0.02,0v-6.3c0-2.11-0.2-4.06-0.57-5.87c12.78-8.69,30.43-0.1,34.06,25.8 c3.49,24.94,18.45,24.05-4.9,24.05l-9.32,0c-0.03,6.35-1.03,9.6,5.56,13.16c6.58,3.56,24.35,5.39,24.35,14.41v5.78 c0,0.46-0.38,0.84-0.85,0.84l-23.37,0V78.73c0-5.75-7.97-6.83-12.17-8.13c-3.84-1.18-8.37-2.58-12.33-4.06 c0.09-1.56-0.04-3.3-0.05-5.32h-9.59c-0.16-0.25-0.27-0.49-0.31-0.73c-0.23-1.17,0.35-2.2,1.16-3.46c0.09-0.12,0.19-0.25,0.27-0.39 l-0.17-0.11v0l0.17,0.1l0.62-0.97l0.22-0.32l-0.01-0.01l6.13-9.78l0.25-0.36l-4.64-2.91l-6.37,10.15c-1.98,3.16-3.79,5.1-3,9.1 c1.75,8.9,27.24,13.91,34.36,17.08v16.86L0,95.49L0,95.49L0,95.49z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupleIcon);
export default __webpack_public_path__ + "static/media/couple-icon.720771f41efd2c03d680bc522f87f3ea.svg";
export { ForwardRef as ReactComponent };